import React, { useState } from "react"
import styled from "styled-components"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
import GoogleLogin from "react-google-login"
import axios from "axios"
import { navigate } from "@reach/router"

import {
  H1,
  H2,
  P,
  Input,
  NextStep,
  FormContainer,
  AbsoluteImg,
  H3,
  InputSVGContainer,
} from "../general/GeneralStyles"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ForgotPasswordModal from "./ForgotPasswordModal"

const Login = styled(NextStep)`
  margin-top: 22px;
  padding: 8px;
`

const Container = styled(FormContainer)`
  padding: 110px 0px;
  ${H2} {
    margin: 10px 0;
  }
`

const FormGrid = styled.div`
  width: 95%;
  max-width: 570px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
  }

  > div span {
    margin-left: 10px;
    margin-right: 10px;
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 14px;
    line-height: 15px;
  }

  hr {
    flex-grow: 1;
    margin-bottom: 0;
  }

  label {
    width: 80%;
    display: inline-block;
  }

  ${P} {
    margin-bottom: 0;
  }
`

const Button = styled.button`
  width: 100%;
  margin-bottom: 12px;
  padding: 9px 0;
  border: none;
  cursor: pointer;
  color: white;

  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
`

const FBButton = styled(Button)`
  background: #3a5998;
`

const GoogleButton = styled(Button)`
  background: #dd4b39;
  margin-bottom: 22px;
`

const PaintDrop = styled(AbsoluteImg)`
  right: 0;
  top: 136px;
`

const StyledLink = styled(Link)`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: right;
  text-decoration: none;
`

const SignUpCTA = styled(P)`
  margin-top: 26px !important;
  text-align: center;
`
/* End Styled Components */

const LoginForm = props => {
  const [formData, setFormData] = useState({})
  const [modalActive, setModalActive] = useState(false)

  const inputHandler = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const responseFacebook = resp => {
    /* TODO: not sure if I should be using id as password */
    console.log(resp)
    let newFormData = {
      ...formData,
      accessToken: resp.accessToken,
      userId: resp.id,
      email: resp.email,
    }
    setFormData(newFormData)
    fbLogin(newFormData)
  }

  const responseGoogle = resp => {
    console.log(resp)
    let newFormData = {
      ...formData,
      ...resp,
      email: resp.profileObj.email,
      password: resp.googleId,
      password_confirmation: resp.googleId,
    }
    setFormData(newFormData)
    googleLogin(newFormData)
  }

  const login = () => {
    console.log("formData")
    console.log(formData)
    axios
      .post("/api/auth/login", formData)
      .then(response => {
        console.log("response")
        console.log(response)
        window.localStorage.setItem("user", JSON.stringify(response.data))
        if (response.data.user.is_admin) {
          navigate("/admin")
        } else {
          navigate("/account")
        }
      })
      .catch(error => {
        alert("Something went wrong please try again")
        console.log(error)
      })
  }

  const googleLogin = newFormData => {
    axios
      .post("/api/auth/googlelogin", newFormData)
      .then(response => {
        window.localStorage.setItem("user", JSON.stringify(response.data))
        if (response.data.user.is_admin) {
          navigate("/admin")
        } else {
          navigate("/account")
        }
      })
      .catch(error => {
        alert("Something went wrong please try again")
        console.log(error)
      })
  }

  const fbLogin = newFormData => {
    axios
      .post("/api/auth/facebooklogin", newFormData)
      .then(response => {
        window.localStorage.setItem("user", JSON.stringify(response.data))
        if (response.data.user.is_admin) {
          navigate("/admin")
        } else {
          navigate("/account")
        }
      })
      .catch(error => {
        alert("Something went wrong please try again")
        console.log(error)
      })
  }

  return (
    <>
      <PaintDrop src="/images/absolute/loginPaintDrop.png" alt="" />

      <Container>
        <H1>Please log In</H1>
        <H3>LOGIN TO CLAIM YOUR FREE PRODUCTS</H3>
        <FormGrid>
          {/* TODO: abstract out these packages or not 🤷🏻‍ */}
          {/* <FacebookLogin
            appId="431279754340937"
            fields="name,email"
            callback={responseFacebook}
            render={renderProps => (
              <FBButton onClick={renderProps.onClick}>
                <FontAwesomeIcon icon={["fab", "facebook-f"]} /> &nbsp; Sign in
                with Facebook
              </FBButton>
            )}
          /> */}
          <GoogleLogin
            clientId="457862953315-opeu11tsghp4d0vla7gvtdqievrb9p21.apps.googleusercontent.com"
            onSuccess={responseGoogle}
            onFailure={responseGoogle}
            render={renderProps => (
              <GoogleButton
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
              >
                <FontAwesomeIcon icon={["fab", "google-plus-g"]} /> &nbsp; Sign
                in with Google
              </GoogleButton>
            )}
          />
          <div>
            <hr />
            <span>Or</span>
            <hr />
          </div>
          <InputSVGContainer>
            <FontAwesomeIcon icon="envelope" />
            <Input
              type="text"
              placeholder="Email Address"
              name="email"
              value={formData.email}
              onChange={inputHandler}
            />
          </InputSVGContainer>
          <InputSVGContainer>
            <FontAwesomeIcon icon="lock" />
            <Input
              type="password"
              placeholder="Password"
              name="password"
              value={formData.password}
              onChange={inputHandler}
            />
          </InputSVGContainer>

          <P>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => setModalActive(true)}
            >
              Forgot Your Password?
            </span>
          </P>
          <Login href="#" onClick={login}>
            Log in
          </Login>
          <SignUpCTA>
            Not a member yet? <StyledLink to="/sign-up">Sign Up</StyledLink>
          </SignUpCTA>
        </FormGrid>
        {modalActive ? (
          <ForgotPasswordModal onClick={() => setModalActive(false)} />
        ) : null}
      </Container>
    </>
  )
}

export default LoginForm
